import { useState } from 'react';
import { DonViCoSo, KhachHang, TaiKhoan } from '@/types/schemas';

/**
 * Hook for managing search field states in the bao-cao-so-du-cong-no feature
 *
 * @returns Object with states and setters for search fields
 */
export const useSearchFieldStates = () => {
  const [account, setAccount] = useState<TaiKhoan[]>([]);
  const [customer, setCustomer] = useState<KhachHang | null>(null);
  const [unit, setUnit] = useState<DonViCoSo | null>(null);

  return {
    account,
    setAccount,
    customer,
    setCustomer,
    unit,
    setUnit
  };
};
